var _defs, _rect, _polygon, _polygon2, _rect2, _rect3, _polygon3, _polygon4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolutionsGrants(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    viewBox: "0 0 66.14 61.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ebeffd;}.cls-2{fill:#ff6e14;}.cls-3{fill:#948dbd;}.cls-4{fill:#544994;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.89,
    y: 13.94,
    width: 32.11,
    height: 40.11
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "37.86 6.96 21.65 6.96 21.65 46.42 53.64 46.42 53.64 22.86 37.86 6.96"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "37.86 6.96 37.86 22.86 53.64 22.86 37.86 6.96"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 17.91,
    y: 40.5,
    width: 17.61,
    height: 4.16
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 21.31,
    y: 28.25,
    width: 17.61,
    height: 4.16,
    transform: "translate(60.22 60.67) rotate(180)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "23.85 24.42 17.91 30.36 23.81 36.25 23.85 24.42"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "32.98 48.5 38.92 42.56 33.02 36.67 32.98 48.5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionsGrants);
export default __webpack_public_path__ + "static/media/Solutions_Grants.48b9476325d3fa6bdab32d5511f1c2f4.svg";
export { ForwardRef as ReactComponent };